<template>
  <v-container class="edit-offer-page" fluid>
    <v-card class="main-card pa-4">
      <!-- Header -->
      <v-row align="center" justify="space-between">
        <v-col cols="9">
          <div class="offer-header">
            <span class="edit-offer-title">Edit Offer</span>
            <span class="custom-offer-name">
              ({{ offer.id }})
              <input
                type="text"
                v-model="offer.name"
                class="offer-name-input"
                placeholder="Enter offer name"
              />
            </span>
          </div>

        </v-col>


        <v-col cols="3" class="text-right save-button-container">
          <v-btn color="primary" class="save-button" @click="saveOffer">
            SAVE
          </v-btn>
        </v-col>
      </v-row>
      <!-- Header Fields -->
      <v-row class="header-info mb-4 no-gutters" align="start" style="padding-top: 10px;">
        <v-col cols="1" class="pr-3">
          <span class="general-field-label">ID</span>
          <v-text-field class="small-input general-input" v-model="offer.id" readonly hide-details />
        </v-col>
        <v-col cols="1" class="pr-3">
          <span class="general-field-label">External ID</span>
          <v-text-field class="small-input general-input" v-model="offer.externalId" hide-details />
        </v-col>
        <v-col cols="1" class="pr-3">
          <span class="general-field-label">Status</span>
          <v-select class="small-input general-input" :items="statuses" v-model="offer.status" hide-details />
        </v-col>
        <v-col cols="2" class="pr-3">
          <span class="general-field-label">Vertical</span>
          <v-autocomplete
            class="medium-input general-input"
            :items="verticals"
            v-model="offer.vertical"
            item-text="name"
            item-value="id"
            hide-details
            placeholder="Select or search vertical"
          />
        </v-col>
        <v-col cols="2" class="pr-3">
          <span class="general-field-label">Advertiser</span>
          <v-autocomplete
            class="large-input general-input"
            :items="advertisers"
            v-model="offer.advertiser"
            item-text="name"
            item-value="id"
            hide-details
            placeholder="Select or search advertiser"
            @change="onAdvertiserChange"
          />
        </v-col>
        <v-col cols="1" class="pr-3">
          <span class="general-field-label">Conversion Type</span>
          <v-select class="medium-input general-input" :items="conversionTypes" v-model="offer.conversionType" hide-details />
        </v-col>
        <v-col cols="2">
          <span class="general-field-label">Offer Manager</span>
          <v-autocomplete
            class="large-input general-input"
            :items="filteredOfferManagers"
            v-model="offer.offerManager"
            item-text="name"
            item-value="id"
            hide-details
            placeholder="Select or search manager"
          />

        </v-col>
      </v-row>

      <!-- Tabs -->
      <v-tabs v-model="tab" grow class="custom-tabs" >
        <v-tab>Overview</v-tab>
        <v-tab>Program</v-tab>
        <v-tab>History</v-tab>
      </v-tabs>
      <!-- Tabs Content -->
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="tab-content-wrapper">
            <v-row class="mt-4">
              <v-col cols="4">
                <span class="general-field-label">Tracking Link</span>
                <div class="field-with-copy">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      class="general-input flex-grow-1"
                      :items="getLpModify()"
                      v-model="offer.trackingLink"
                      item-text="text"
                      item-value="text"
                      hide-details
                      placeholder="Search or add landing page..."
                      :search-input.sync="trackingLinkInput"
                      @change="selectTrackingLink"
                      @keydown.enter.native="handleAddTrackingLink"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Press <b>Enter</b> to add "<span>{{ trackingLinkInput }}</span>"
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>

<!--                    <v-btn-->
<!--                      v-if="trackingLinkInput && trackingLinkInput.trim() !== ''"-->
<!--                      icon-->
<!--                      small-->
<!--                      @click="handleAddTrackingLink"-->
<!--                    >-->
<!--                      <v-icon small>mdi-plus</v-icon>-->
<!--                    </v-btn>-->

<!--                    <v-btn icon small @click="copyToClipboard(offer.trackingLink)">-->
<!--                      <v-icon small>mdi-content-copy</v-icon>-->
<!--                    </v-btn>-->
                  </div>



                    <v-btn
                      class="copy-btn"
                      text
                      small
                      color="primary"
                      style="padding-top: 5px !important;"
                      @click="showCustomLPModal(offer.id)"
                    >
                      <v-icon small >mdi-link-variant</v-icon>
                      Manage Links
                    </v-btn>

                    <CustomLP
                      :id="'modal_lp' + offer.id"
                      :ref="'modal_lp' + offer.id"
                      :customLPId="offer.id"
                      :defaultLp="offer.trackingLink"
                      :customLPRules="getOffer.customLPRules && JSON.parse(getOffer.customLPRules)"
                    />
                </div>

                <!-- Description -->
                <div class="field-with-copy">
                  <div class="label-with-button">
                    <span class="general-field-label">Description</span>
                    <v-btn class="copy-btn" text small color="primary" @click="copyToClipboard(offer.description)">
                      <v-icon small left>mdi-content-copy</v-icon>
                      Copy Description
                    </v-btn>
                  </div>

                  <v-textarea
                    class="general-input"
                    v-model="offer.description"
                    rows="3"
                    hide-details
                  />
                </div>

              </v-col>


              <v-col cols="4">
                <div class="field-with-copy">
                  <span class="general-field-label">Preview Link</span>
                  <v-text-field
                    class="general-input"
                    v-model="offer.previewLink"
                    hide-details
                  />
                  <v-btn class="copy-btn" text small color="primary" @click="copyToClipboard(offer.previewLink)">
                    <v-icon small left>mdi-content-copy</v-icon>
                    Copy Link
                  </v-btn>
                </div>

                <div class="field-with-copy">
                  <span class="general-field-label">Restrictions</span>
                  <v-textarea
                    class="general-input"
                    v-model="offer.restrictions"
                    rows="3"
                    hide-details
                  />
                  <v-btn class="copy-btn" text small color="primary" @click="copyToClipboard(offer.restrictions)">
                    <v-icon small left>mdi-content-copy</v-icon>
                    Copy Restrictions
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="4">
                <div class="field-with-copy">
                  <span class="general-field-label">Postback Url</span>
                  <v-text-field
                    class="general-input"
                    v-model="offer.postbackUrl"
                    hide-details
                  />
                  <v-btn class="copy-btn" text small color="primary" @click="copyToClipboard(offer.postbackUrl)">
                    <v-icon small left>mdi-content-copy</v-icon>
                    Copy Link
                  </v-btn>
                </div>

                <div class="field-with-copy">
                  <span class="general-field-label">Internal Notes</span>
                  <v-textarea
                    class="general-input"
                    v-model="offer.internalNotes"
                    rows="3"
                    hide-details
                  />
                  <v-btn class="copy-btn" text small color="primary"  @click="copyToClipboard(offer.internalNotes)">
                    <v-icon small left>mdi-content-copy</v-icon>
                    Copy Notes
                  </v-btn>
                </div>
              </v-col>
            </v-row>
<!--            GEO Settings-->
            <v-row class="mt-4">
              <v-col cols="12">
                <!-- Banned GEOs -->
                <div class="geo-section">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <span class="geo-label banned">BANNED GEOs:</span>
                    <div class="d-flex align-center">
                      <v-btn text small color="primary" class="geo-action-btn" @click="copyToClipboard(getBannedCountries())">
                        <v-icon small left>mdi-content-copy</v-icon>
                        Copy BANNED GEOs
                      </v-btn>
                      <v-btn text small color="primary" class="geo-action-btn" @click="showGeoRestrictionsModal(offer.id)">
                        <v-icon small left>mdi-cog</v-icon>
                        Manage GEOs
                      </v-btn>
                    </div>
                  </div>
                  <span class="geo-content">
                    {{ getBannedCountries() }}
                  </span>
                </div>

                <!-- Allowed GEOs -->
                <div class="geo-section mt-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <span class="geo-label allowed">ALLOWED GEOs:</span>
                    <div class="d-flex align-center">
                      <v-btn text small color="primary"  class="geo-action-btn"  @click="copyToClipboard(getAllowedCountries())">
                        <v-icon small left>mdi-content-copy</v-icon>
                        Copy ALLOWED GEOs
                      </v-btn>
                      <v-btn text small color="primary"  class="geo-action-btn"  @click="showGeoRestrictionsModal(offer.id)">
                        <v-icon small left>mdi-cog</v-icon>
                        Manage GEOs
                      </v-btn>
                    </div>
                  </div>
                  <span class="geo-content">
                    {{ getAllowedCountries() }}
                  </span>
                </div>
              </v-col>

              <GeoRestrictions
                :id="'modal_' + offer.id"
                :ref="'modal_' + offer.id"
                :geoId="offer.id"
                :geoRules="getOffer.geoRules && getOffer.geoRules"
                :offerDefaultLPInfo="getDefaultLPInfo(getOffer.defaultLp)"
              />
            </v-row>


            <v-row class="mt-4">
              <!-- Program Column -->
              <v-col cols="6">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="section-title">Program</span>
                  <div>
                    <v-btn text small color="primary"  class="geo-action-btn"  @click="exportProgramToCSV">
                      <v-icon small left>mdi-export</v-icon>
                      Export Program
                    </v-btn>

                    <v-btn text small color="primary"   class="geo-action-btn" @click="tab = 1">
                      <v-icon small left>mdi-pencil</v-icon>
                      Manage Program
                    </v-btn>
                  </div>
                </div>

                <!-- Active Program Selector -->
                <v-autocomplete
                  hide-details
                  label="Active Program"
                  readonly
                  disabled
                  v-model="activeProgramId"
                  :items="programsPrepared"
                  placeholder="Start typing to Search"
                />

                <!-- Program Table -->
                <v-simple-table dense class="mt-2">
                  <thead>
                  <tr>
                    <th class="text-center">Code</th>
                    <th class="text-center">Geo</th>
                    <th class="text-center">Payout ({{ programCurrencyAbbr }})</th>
                    <th class="text-center">Price ({{ programCurrencyAbbr }})</th>
                    <th class="text-center">Margin</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(program, index) in preparedProgramsForTable" :key="index">
                    <td class="text-center">{{ program.geo }}</td>
                    <td class="text-center">{{ program.countryName }}</td>
                    <td class="text-center">{{ program.payout }}</td>
                    <td class="text-center">{{ program.price }}</td>
                    <td class="text-center">{{ program.margin }}</td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <!-- Caps Column -->
              <v-col cols="6">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="section-title">Caps</span>
                  <v-btn text small color="primary"   class="geo-action-btn" @click="showCapsModal(offer.id)">
                    <v-icon small left>mdi-pencil</v-icon>
                    Manage Caps
                  </v-btn>
                </div>
                <v-simple-table dense>
                  <thead>
                  <tr>
                    <th style="width: 60%;">Cap Type</th>
                    <th style="width: 40%;">Cap Value</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in prepareCapRows()" :key="index">
                    <td style="width: 60%;"><span class="pl-1">{{ row.type }}</span></td>
                    <td style="width: 40%;"><span class="pl-3">{{ row.value }}</span></td>
                  </tr>
                  </tbody>
                </v-simple-table>
                <!-- Caps Modal Component -->
                <Caps
                  :id="'modal_caps' + offer.id"
                  :ref="'modal_caps' + offer.id"
                  :offerId="offer.id"
                  :offerCap="getOfferCap"
                  :offers="getOffersModify()"
                />
              </v-col>

            </v-row>
            <v-row class="mt-4">
              <v-progress-circular
                      v-if="loadingCustomOptions"
                      indeterminate
                      color="primary"
              />
              <CustomOptionsManagerV2
                      v-else
                      :customOptions.sync="customOptions"
                      :offerId="Number(this.offer.id)"
                      @update:deletedIds="handleDeletedOptionIds"
              />
            </v-row>
            <v-row class="mt-4">
              <v-progress-circular
                v-if="loadingVariants"
                indeterminate
                color="primary"
              />
              <VariantManagerV2
                v-else
                :variants="variants"
                :offerId="Number(this.offer.id)"
              />
            </v-row>

          </div>
        </v-tab-item>
        <!-- Program Tab -->
        <v-tab-item>
          <div class="tab-content-wrapper">
            <v-container fluid>
              <v-row no-gutters>
                <v-col cols="5">
                  <v-autocomplete
                    hide-details
                    :disabled="!user[0].can('assign_programs')"
                    label="Active Program"
                    v-model="activeProgramId"
                    :items="programsPrepared"
                    placeholder="Start typing to Search"
                  />
                </v-col>
                <v-spacer />
                <v-col cols="5" class="d-flex align-center justify-end text-right">
                  <a v-if="user[0].can('create_programs')"
                     class="new-program"
                     @click="newProgram()"
                  >
                    <b>Need a new program?</b>
                    <v-icon>mdi-open-in-new</v-icon>
                  </a>
                </v-col>
                <v-col cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">Code</th>
                        <th class="text-center">Geo</th>
                        <th class="text-center">Payout ( <span v-text="programCurrencyAbbr"></span> )</th>
                        <th v-if="user[0].can('see_profit')" class="text-center">Price ( <span v-text="programCurrencyAbbr"></span> )</th>
                        <th v-if="user[0].can('see_profit')" class="text-center">Margin</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(program, index) in preparedProgramsForTable" :key="index">
                        <td class="text-center">{{ program.geo }}</td>
                        <td class="text-center">{{ program.countryName }}</td>
                        <td class="text-center">{{ program.payout }}</td>
                        <td v-if="user[0].can('see_profit')" class="text-center">{{ program.price }}</td>
                        <td v-if="user[0].can('see_profit')" class="text-center">{{ program.margin }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-tab-item>

         <!-- History Tab -->
        <v-tab-item>
          <div class="tab-content-wrapper">
            <table class="table table-striped child-row tableFixHead lp-table no-border">
              <thead>
              <tr scope="row">
                <th scope="col">User (E-mail)</th>
                <th scope="col">Date/Time</th>
                <th scope="col">Action</th>
                <th scope="col">Changes</th>
              </tr>
              </thead>
              <tr scope="row" v-for="(history, index) in getOfferHistoryModify() " :key="index">
                <td class="text-center" >
                  <span>{{history.user}}</span>
                </td>
                <td class="text-center" >
                  <span>{{ formatDate_(new Date(history.dateAdded * 1000)) }}</span>
                </td>
                <td class="text-center" >
                  <span>{{ history.action }}</span>
                </td>
                <td class="text-left" style="padding-left: 15% !important;">
                  <HistoryLog :logsString='history.logs' ></HistoryLog>
                </td>
              </tr>
            </table>
          </div>
        </v-tab-item>
      </v-tabs-items>

    </v-card>
  </v-container>
</template>




<script>
import affiliates from "@/api/affiliates";
import programs from "@/api/programs";
import {cloneObjectArray, formatData} from "@/helpers";
import {mapGetters, mapMutations, mapState} from "vuex";
import offerApi from "@/api/offer";
import offerCustomOptionsApi from '@/api/offerCustomOptions';
import CustomLP from './CustomLP'
import GeoRestrictions from "@/components/pages/advertisers/offers/GeoRestrictions.vue";
import Caps from "@/components/pages/advertisers/offers/Caps.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import Confirm from "@/components/common/Confirm.vue";
import HistoryLog from "@/components/common/HistoryLog.vue";
import FileManager from "@/components/common/FileManager.vue";
import VariantManager from "@/components/pages/advertisers/offers/VariantManager.vue";
import VariantManagerV2 from "@/components/pages/advertisers/offers/VariantManagerV2.vue";
import CustomOptionsManagerV2 from "@/components/pages/advertisers/offers/CustomOptionsManagerV2.vue";
import offerVariants from "@/api/offerVariants";

export default {
  name: 'EditOfferV2',
  components: {
    VariantManagerV2,
    CustomOptionsManagerV2,
    VariantManager,
    GeoRestrictions,
    Caps,
    CustomLP,
    MainLayout,
    Confirm,
    HistoryLog,
    FileManager
  },
  data() {
    return {
      trackingLinkInput: '',
      searchTrackingLink: '',
      programList: [],
      programDetails: [],
      activeProgram: null,
      activeProgramId: null,
      originProgramId: null,
      tempIndex: 0,
      tab: 0,
      loading: false,
      platform: null,
      allowedCountries: [],
      isAllCountriesAllowed: false,
      lp: [],
      fastLpAdd: false,
      fastLpValue: '',
      isRestricted: false,
      marginType: '1',
      offer: {
        id: this.$route.params.id || '',
        externalId: '',
        name: '',
        status: '',
        vertical: '',
        advertiser: '',
        conversionType: '',
        offerManager: '',
        description: '',
        restrictions: '',
        internalNotes: '',
        postbackUrl: '',
        previewLink: '',
        trackingLink: '',
        defaultLp: '',
      },
      statuses: ['public','private','apply_to_run','inactive','pending','draft'],
      verticals: [],
      variants: [],
      customOptions: [],
      customOptionsToDelete: [],
      loadingVariants: false,
      loadingCustomOptions: false,
      advertisers: [],
      conversionTypes: ['cpi','cpa','cpl','cpc','cpm'],
      offerManagers: []
    }
  },
  watch: {
    getOfferVariants: {
      immediate: true, // Run immediately on component mount
      handler(newVariants) {
        this.variants = newVariants || []; // Update local state when getOfferVariants changes
      },
    },

    async activeProgramId() {
      if (!this.activeProgramId || isNaN(this.activeProgramId)) return;
      const allowCountries = this.allowedCountries;
      const programDetails = await programs.getProgramDetails(this.activeProgramId);

      if (allowCountries.length !== 0 && !this.isAllCountriesAllowed) {
        this.programDetails = programDetails.filter(detail => allowCountries.includes(detail.geo));
      } else {
        this.programDetails = programDetails;
      }

      this.activeProgram = this.programList.find(program => program.id === this.activeProgramId);
      this.tempIndex = 0;
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('offer', [
      'getOffer',
      'getOfferOrigin',
      'getOfferCap',
      'getOfferCapOrigin',
      'getOfferGeo',
      'getOfferGeoOrigin',
      'getCustomLPRules',
      'getCustomLPRulesOrigin',
      'getExitTrafficOffers',
      'getOfferVariants'
    ]),
    ...mapGetters('offers', ['getOffers']),
    ...mapGetters('offerHistory', ['getOfferHistory']),
    ...mapGetters('lpOffers', ['getLpOffers', 'getLpOffersOrigin']),
    ...mapGetters('countries', ['getCountries']),
    ...mapGetters('advertisers', ['getSflAdvertisers', 'getSflAdvertisersManagers']),
    ...mapGetters('verticals', ['getVerticals']),
    programsPrepared() {
      const tempProgramList = JSON.parse(JSON.stringify(this.programList));
      tempProgramList.map(program => {
        program['text'] = `${program.name} (${program.id})`;
        program['value'] = program.id;
      });
      return tempProgramList;
    },
    preparedProgramsForTable() {
      const preparedProgramsForTable = [...this.programDetails];

      const activeProgramData = this.programList.find(value => value.id === this.activeProgramId) || {};

      const marginPercent = activeProgramData && activeProgramData.marginType === 'fixed'
        ? Math.round((1 - (activeProgramData.payout / activeProgramData.price)) * 100)
        : activeProgramData.marginPercent;

      const defaultData = {
        countryName: 'Worldwide (Default)',
        geo: 'WW',
        price: activeProgramData.price || 0,
        payout: activeProgramData.payout || 0,
        margin: `${Math.round((activeProgramData.price - activeProgramData.payout) * 100) / 100} (${marginPercent || '0'}%)`,
      };

      if (activeProgramData.payout > 0) {
        preparedProgramsForTable.unshift(defaultData);
      }

      return preparedProgramsForTable;
    },
    programCurrencyAbbr() {
      return this.activeProgram ? this.activeProgram.currencyAbbr : 'USD';
    },
    filteredOfferManagers() {
      const username = this.user[0].name;
      const formattedName = username
        .split('.')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');

      return this.offerManagers.map(manager => ({
        ...manager,
      }));
    }
  },
  async mounted() {
    this.loading = true;
    this.loadingVariants = true;
    document.title = `Offer-${this.$route.params.id}`;

    this.platform = await affiliates.getPlatform();
    await this.$store.dispatch('offer/saveExitTrafficOffersStore');
    await this.$store.dispatch('offer/saveOfferStore', this.offer.id);
    const allowedCountries = await programs.getAllowedCountriesByOfferId(this.offer.id);
    this.allowedCountries = allowedCountries.countries || [];
    this.isAllCountriesAllowed = allowedCountries.isAllCountriesAllowed;

    await this.fetchCustomOptions();

    await this.$store.dispatch('offer/saveOfferCapStore', this.offer.id);
    await this.$store.dispatch('lpOffers/saveLpOffersStore', this.offer.id);
    await this.$store.dispatch('advertisers/saveSflAdvertisersStore', {
      limit: 1500,
      page: 1,
      orderBy: 'name',
      orderDirectionAsc: true,
      filters: { status: "'active'" }
    });
    await this.$store.dispatch('advertisers/saveSflAdvertisersManagersStore');
    await this.$store.dispatch('verticals/saveVerticalsStore');
    await this.$store.dispatch('countries/saveCountriesStore');
    await this.$store.dispatch('offerHistory/saveOfferHistoryStore', this.offer.id);

    // console.log(`this.getLpOffers: ${JSON.stringify(this.getLpOffers)}`);
    this.lp = this.getLpOffers || [];

    // console.log(`this.lp: ${JSON.stringify(this.lp)}`);
    this.isRestricted = this.getOffer.isRestricted;
    this.marginType = this.getOffer.marginType === 'fixed' ? '1' : '2';
    this.programList = await programs.getProgramsList();
    await this.fetchProgramData();
    this.originProgramId = this.getOffer.programId;

    if (!this.getOffer.id) {
      await this.$router.push('/403');
    }
    // console.log(`Offer ID: ${this.offer.id}`);
    // console.log(`this.getOffer: ${JSON.stringify(this.getOffer)}`);
    let postback = ''
    if (this.getOffer.advertiserId){
      const res = await offerApi.getPostback(this.getOffer.advertiserId);
      postback = res.value;
    }

    let lpModify = cloneObjectArray(this.getLpOffers)
    const LP = lpModify.map(item => {
      item.value = item.id
      item.text = `${item.url}`
      return item
    })

    const defaultLP = LP.find(item => item.id === this.getOffer.defaultLp);

    let trackingLink = defaultLP ? defaultLP.text : '';

    await this.$store.dispatch('offer/saveOfferVariantsStore', this.offer.id)
    console.log(`this.getOfferVariants mount: ${JSON.stringify(this.getOfferVariants)}`);

    this.variants = this.getOfferVariants || [];
    this.loadingVariants = false;
    console.log(`this.variants: ${JSON.stringify(this.variants)}`);
    this.offer = {
      id: this.getOffer.id || '',
      name: this.getOffer.name || '',
      externalId: this.getOffer.externalId || '',
      status: this.getOffer.status || '',
      vertical: this.getOffer.verticalId || '',
      advertiser: this.getOffer.advertiserId || '',
      conversionType: this.getOffer.conversionType || '',
      offerManager: this.getOffer.advertiserManagerId || '',

      description: this.getOffer.descriptions !== "null" ? this.getOffer.descriptions : '',
      restrictions: this.getOffer.restrictions !== "null" ? this.getOffer.restrictions : '',
      internalNotes: this.getOffer.internalNotes !== "null" ? this.getOffer.internalNotes : '',
      trackingLink: trackingLink,
      previewLink:  this.getOffer.previewLink || ``,
      postbackUrl: postback,
      defaultLp: this.getOffer.defaultLp,
    }
    // console.log(`.advertiser: ${JSON.stringify(this.getSflAdvertisers)}`);
    this.advertisers = this.getSflAdvertisers;
    this.offerManagers = this.getSflAdvertisersManagers.map(manager => ({
      id: manager.id,
      name: `${manager.firstName} ${manager.lastName}`
    }));
    this.setOfferManager();
    // console.log(`.offerManagers: ${JSON.stringify(this.offerManagers)}`);
    this.verticals = this.getVerticals

    // console.log(`.verticals: ${JSON.stringify(this.verticals)}`);
    // console.log(`.offerManagers: ${JSON.stringify(this.offerManagers)}`);
    this.loading = false;
  },
  methods: {
    ...mapMutations('lpOffers', ['fastAddLpOffers']),
    getOfferHistoryModify() {
      return this.getOfferHistory.length !== 0 && this.getOfferHistory
    },
    formatDate_(date) {
      return formatData(date)
    },
    setOfferManager() {
      let rawUsername = this.user[0]?.name || '';

      if (!rawUsername) {
        const rawEmail = this.user[0]?.email || '';
        console.warn('[setOfferManager] Username is empty. Trying to extract from email:', rawEmail);

        if (rawEmail.includes('@')) {
          rawUsername = rawEmail.split('@')[0];   // Берем часть до @
          console.log('[setOfferManager] Extracted username from email:', `"${rawUsername}"`);
        } else {
          console.warn('[setOfferManager] Email is invalid or empty. Cannot determine username.');
          return;
        }
      } else {
        console.log('[setOfferManager] Raw username:', `"${rawUsername}"`);
      }

      let firstName = '';
      let lastName = '';

      const usernamePart = rawUsername.trim();

      if (usernamePart.includes('.') && !usernamePart.includes(' ')) {
        [firstName, lastName] = usernamePart.split('.').map(part =>
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        );
      } else {
        const parts = usernamePart.split(' ');
        firstName = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
        lastName = parts[1] ? parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase() : '';
      }

      const fullName = `${firstName} ${lastName}`.trim();

      console.log('[setOfferManager] Parsed Full Name:', `"${fullName}"`);

      let foundManager = this.offerManagers.find(manager =>
        manager.name === fullName
      );

      if (!foundManager && lastName) {
        console.warn(`[setOfferManager] Full name "${fullName}" not found. Trying to find by last name: "${lastName}"`);

        foundManager = this.offerManagers.find(manager =>
          manager.name.split(' ')[1] === lastName
        );
      }

      if (foundManager) {
        this.offer.offerManager = foundManager.id;
        console.log(`[setOfferManager] Manager assigned: "${foundManager.name}" (ID: ${foundManager.id})`);
      } else {
        console.warn(`[setOfferManager] Manager NOT FOUND for: "${fullName}" or last name "${lastName}"`);
        console.warn('[setOfferManager] Available managers:', this.offerManagers.map(m => m.name));
      }
    },

    getBannedCountries() {
      if (this.getOffer.geoRules) {

        let geoR = JSON.parse(this.getOffer.geoRules)
        let geoCountry = geoR.geo.map(item => item.country)
        return geoCountry.join(', ')
      }
    },
    getDefaultLPInfo(defaultLp) {
      if (!defaultLp) return
      return this.getLpOffers.filter(item => {
        return item.id === defaultLp
      })
    },
    getAllowedCountries() {
      if (this.getOffer.geoRules) {
        let geoR = JSON.parse(this.getOffer.geoRules);
        let bannedCountries = geoR.geo.map(item => item.country);

        const allCountries = this.getCountries.map(item => item.code);
        const allowedCountries = allCountries.filter(country => !bannedCountries.includes(country));

        return allowedCountries.join(', ');
      }
      return '';
    },
    newProgram() {
      window.open(`/advertisers/programs/create`, '_blank');
    },
    async fetchProgramData() {
      const activeProgramId = this.getOffer.programId;
      const result = this.programList.find(value => value.id === activeProgramId);
      this.activeProgramId = result ? result.id : null;
      this.activeProgram = result;
    },

    handleAddTrackingLink() {
      let newUrl = this.trackingLinkInput.trim();

      console.log(`Adding new tracking link: ${newUrl}`);
      if (!newUrl) return;

      if (!newUrl.startsWith('http')) {
        newUrl = `http://${newUrl}`;
      }

      const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

      if (!urlPattern.test(newUrl)) {
        this.$dialog.notify.error('Invalid URL format!');
        return;
      }

      const exists = this.lp.some(item => item.url === newUrl);

      if (!exists) {
        this.fastAddLpOffers({
          url: newUrl,
          offerId: this.offer.id
        });

        const addedLp = this.lp.find(item => item.url === newUrl);

        if (addedLp) {
          this.offer.trackingLink = addedLp.url;
          this.offer.defaultLp = addedLp.id;
        }

        this.$dialog.notify.success('New Landing Page added!');
      } else {
        const existing = this.lp.find(item => item.url === newUrl);
        this.offer.trackingLink = existing.url;
        this.offer.defaultLp = existing.id;
      }

      this.trackingLinkInput = '';
    },

    selectTrackingLink(selectedUrl) {
      const selected = this.lp.find(item => item.url === selectedUrl);

      if (selected) {
        this.offer.defaultLp = selected.id;
      }
    },
    getLpModify() {
      return this.lp.map(item => ({
        text: item.url,
        value: item.id
      }));
    },
    updateDefaultLpByName(selectedUrl) {
      const selectedLP = this.lp.find(item => item.url === selectedUrl);
      if (selectedLP) {
        this.offer.defaultLp = selectedLP.id;
        console.log(`Default LP updated to ID: ${selectedLP.id}`);
      }
    },
    async onAdvertiserChange(newAdvertiserId) {
      console.log(`Selected advertiser ID: ${newAdvertiserId}`);
      try {
        const res = await offerApi.getPostback(newAdvertiserId);
        this.offer.postbackUrl = res.value;
      } catch (error) {
        console.error('Failed to fetch postback URL:', error);
        this.offer.postbackUrl = '';
      }
    },
    getOffersModify() {
      return this.getExitTrafficOffers
    },
    showGeoRestrictionsModal(id) {
      let modal_id = 'modal_' + id

      this.$refs[modal_id].show(id)
      console.log('this.$refs[modal_id]-', this.$refs[modal_id])
    },
    showCapsModal(id) {
      const modalRef = this.$refs['modal_caps' + id];

      if (modalRef && typeof modalRef.show === 'function') {
        modalRef.show(id);
        console.log('Opened Caps modal:', modalRef);
      } else {
        console.warn(`Modal with ref 'modal_caps${id}' not found or 'show' method is missing.`);
      }
    },

    showCustomLPModal(id) {
      const modalRef = this.$refs['modal_lp' + id];

      if (modalRef && typeof modalRef.show === 'function') {
        modalRef.show(id);
        console.log('Opened modal:', modalRef);
      } else {
        console.warn(`Modal with ref 'modal_lp${id}' not found or 'show' method is missing.`);
      }
    },

    copyToClipboard(value) {
      if (!value) return;
      navigator.clipboard.writeText(value).then(() => {
        this.$dialog.notify.success('Copied to clipboard!');
      });
    },
    exportProgramToCSV() {
      const headers = ['Code', 'Geo', `Payout (${this.programCurrencyAbbr})`, `Price (${this.programCurrencyAbbr})`, 'Margin'];

      const rows = this.preparedProgramsForTable.map(program => [
        program.geo,
        program.countryName,
        program.payout,
        program.price,
        program.margin
      ]);

      let csvContent = '';
      csvContent += headers.join(',') + '\n';

      rows.forEach(rowArray => {
        const row = rowArray.map(value => `"${value}"`).join(',');
        csvContent += row + '\n';
      });


      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `program_export_offer_${this.offer.id}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleDeletedOptionIds(ids) {
        this.customOptionsToDelete = ids;
    },
    async saveOffer() {
      try {
        console.log(`Saving offer with ID: ${this.offer.id}`, JSON.stringify(this.offer));
        console.log('[CUSTOM_OPTIONS]', this.customOptions);    
        const advertiserObj = this.advertisers.find(a => a.id === this.offer.advertiser);
        const advertiserName = advertiserObj ? advertiserObj.name : '';

        const verticalObj = this.verticals.find(v => v.id === this.offer.vertical);
        const verticalName = verticalObj ? verticalObj.name : '';

        const missingFields = [];

        if (!this.offer.advertiser) {
          missingFields.push('Advertiser');
        }

        if (!this.activeProgramId) {
          missingFields.push('Program');
        }

        if (!this.offer.defaultLp) {
          missingFields.push('Tracking link');
        }

        if (missingFields.length > 0) {
          await this.$dialog.notify.error(
            `There are some errors, please fill the following fields:<br>- ${missingFields.join('<br>- ')}`
          );
          return;
        }

        // --- Start of Variant Saving Logic ---
        // Validate and save variants
        for (const variant of this.variants) {
          // Normalize params (same as in VariantManagerV2.vue)
          if (typeof variant.params === 'string') {
            try {
              variant.params = JSON.parse(variant.params);
            } catch (e) {
              console.error('Invalid params format', e);
              variant.params = [];
            }
          }
          if (!Array.isArray(variant.params)) {
            variant.params = [];
          }

          // Parse extraParamsInput to update variant.params
          const input = variant.extraParamsInput.trim();
          const regex = /&(\w+)=([\w-]+)/g;
          let match;
          const params = [];

          while ((match = regex.exec(input)) !== null) {
            params.push({ name: match[1], value: match[2] });
          }

          if (params.length === 0 && input !== '') {
            await this.$dialog.notify.error(`Invalid extra params for variant ${variant.name}: Use format &key=value`, {
              position: 'top-right',
              timeout: 6000,
            });
            return;
          } else {
            variant.params = params;
          }

          // Save the variant
          await offerVariants.updateOfferVariant(
            variant.id,
            variant.name,
            '',
            variant.imageName || '',
            JSON.stringify(variant.params),
            variant.isDefault,
            this.offer.id
          );
        }

        for (const id of this.customOptionsToDelete) {
            await offerCustomOptionsApi.deleteOfferCustomOption(id);
        }

        for (const option of this.customOptions) {
            if (option.id) {
              console.log('Updating custom option:', option);
                await offerCustomOptionsApi.updateOfferCustomOption(
                    option.id,
                    option.optionName,
                    option.optionValue,
                    option.optionParameter,
                    option.availableProgramIds
                );
            } else {
              console.log('Creating custom option:', option);
                await offerCustomOptionsApi.createOfferCustomOption(
                    this.offer.id,
                    option.optionName,
                    option.optionValue,
                    option.optionParameter,
                    option.availableProgramIds
                );
            }
        }
        this.customOptionsToDelete = [];

        // Check if there is at least one default variant
        const hasDefaultVariant = this.variants.some(variant => variant.isDefault === true);
        if (!hasDefaultVariant) {
          await this.$dialog.notify.error('At least one variant must be set as default', {
            position: 'top-right',
            timeout: 6000,
          });
          return;
        }
        // Update the Vuex store with the latest variants
        await this.$store.dispatch('offer/saveOfferVariantsStore', this.offer.id);

        // Re-sync extraParamsInput with variant.params after saving
        for (const variant of this.variants) {
          const paramsString = variant.params.map(param => `&${param.name}=${param.value}`).join('');
          this.$set(variant, 'extraParamsInput', paramsString);
          this.$set(variant, 'paramError', '');
        }

        await this.$dialog.notify.success('Variants saved successfully!', { position: 'top-right', timeout: 1000 });
        // --- End of Variant Saving Logic ---

        const data = {
          id: Number(this.offer.id),
          name: this.offer.name,
          advertiserId: Number(this.offer.advertiser),
          advertiserManagerId: Number(this.offer.offerManager),
          advertiserName: advertiserName,
          verticalId: Number(this.offer.vertical),
          verticalName: verticalName,
          conversionType: this.offer.conversionType,
          currencyId: this.getOffer.currencyId || 1,
          geoRules: this.getOffer.geoRules || '',
          customLPRules: this.getOffer.customLPRules || '',
          caps: this.getOfferCap || '',
          lp: this.lp || '',
          descriptions: this.offer.description || '',
          restrictions: this.offer.restrictions || '',
          payIn: this.getOffer.payIn || 0,
          payOut: this.getOffer.payOut || 0,
          status: this.offer.status,
          defaultLp: this.offer.defaultLp || 0,
          defaultSiteName: this.offer.trackingLink || '',
          offerIdRedirect: this.getOffer.offerIdRedirect || 0,
          marginType: String(this.marginType),
          payoutPercent: this.getOffer.payoutPercent || 0,
          isCpmOptionEnabled: this.getOffer.isCpmOptionEnabled ? 1 : 0,
          useStartEndDate: this.getOffer.useStartEndDate ? 1 : 0,
          startDate: this.getOffer.startDate || '',
          endDate: this.getOffer.endDate || '',
          isRestricted: this.isRestricted ? true : false,
          programId: this.activeProgramId || 0,
          externalId: this.offer.externalId || '',
          internalNotes: this.offer.internalNotes || '',
          previewLink: this.offer.previewLink || ''
        };

        console.log(`Saving offer data:`, JSON.stringify(data));
        const res = await offerApi.saveOffer(data);
        if (res && res.id) {
          await this.$dialog.notify.success('Offer saved successfully!');
          await this.fetchCustomOptions();
        } else {
          await this.$dialog.notify.error('Failed to save offer.');
        }
      } catch (error) {
        console.error('Error saving offer:', error);
        await this.$dialog.notify.error('An error occurred while saving the offer.');
      }
    },

    prepareCapRows() {
      const cap = this.getOfferCap;

      if (!cap || cap.enabled === 0) {
        return [{ type: '-', value: 'No limit' }];
      }

      const capMapping = {
        clickDay: 'Daily - Clicks',
        clickWeek: 'Weekly - Clicks',
        clickMonth: 'Monthly - Clicks',
        salesDay: 'Daily - Conversions',
        salesWeek: 'Weekly - Conversions',
        salesMonth: 'Monthly - Conversions',
      };

      const rows = Object.entries(capMapping)
              .filter(([key]) => cap[key] && cap[key] > 0)
              .map(([key, label]) => ({
                type: label,
                value: cap[key],
              }));

      if ((cap.startDate || cap.endDate) && rows.length) {
        rows.push({
          type: 'Date Range',
          value: `${cap.startDate || '-'} / ${cap.endDate || '-'}`,
        });
      }

      return rows.length > 0 ? rows : [{ type: '-', value: 'No limit' }];
    },

    async fetchCustomOptions() {
      this.loadingCustomOptions = true;
      try {
        const options = await offerCustomOptionsApi.getOfferCustomOptions(this.offer.id);
        this.customOptions = options;
      } catch (error) {
        console.error('Error fetching custom options:', error);
      } finally {
        this.loadingCustomOptions = false;
      }
    },
  }
}
</script>

<style scoped>

.header-info .v-col {
  min-width: 120px;
  max-width: 200px;
}

.offer-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.edit-offer-title {
  font-size: 20px;
  font-weight: 500;
}

.custom-offer-name {
  font-size: 16px;
  background-color: transparent;
  border-bottom: 1px solid #E0E6ED;
  padding: 2px 0 4px 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 750px;
}

.offer-name-input {
  border: none;
  background: transparent;
  font-size: 16px;
  width: auto;
  min-width: 300px;
}

.offer-name-input:focus {
  outline: none;
  border-bottom: 1px solid #1276ac;
}


.custom-offer-name input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}


.field-with-copy {
  position: relative;
  margin-bottom: 24px;
}

.copy-btn {
  background-color: transparent !important;
  box-shadow: none !important;
  padding-top: 12px !important;
  margin-top: 7px !important;
  min-width: 0 !important;
  height: auto !important;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: normal;
}

.copy-btn:hover {
  background-color: transparent !important;
}

.copy-btn .v-icon {
  margin-right: 4px;
}


.copy-btn {
  position: absolute;
  top: -15px;
  right: 0;
}

.copy-btn .v-icon {
  margin-right: 4px;
}


::v-deep .v-btn {
  font-weight: 600;
  font-size: 12px;
  text-transform: none;
  padding: 0 6px;
}

.tab-content-wrapper {
  background-color: #FFFFFF;
  padding: 10px;
  border: 1px solid #E3EEF4;
  border-radius: 8px;
}


.edit-offer-page {
  padding: 20px;
}


.main-card {
  background-color: #F7F8FC !important;
  border-radius: 1px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  padding: 2px !important;
  border: none !important;
}

.custom-tabs {
  ::v-deep .v-tab {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 14px;
    color: #29769e !important;
    min-width: 120px;
    background-color: #1836ae !important;
    transition: background-color 0.3s;
  }

  ::v-deep .v-tab--active {
    color: #ffffff !important;
    background-color: #26C6DA !important;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 2px solid #26C6DA;
    z-index: 2;
  }

  ::v-deep .v-tabs-bar {
    border-bottom: 1px solid #E3EEF4;
    background-color: transparent !important;
  }
}

.general-input {
  margin-top: 8px;
  font-size: 13px;
}

.general-field-label {
  font-family: "Proxima Nova", Arial, Helvetica, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #7F98A5;
  margin-bottom: -15px;
  display: block;
}

::v-deep .v-input__control {
  border-bottom: none !important;
}

::v-deep .v-input__slot {
  border: 1px solid #e0e6ed !important;
  border-radius: 6px;
  background-color: #fff;
  padding: 8px 12px;
}

::v-deep .v-input__slot::before,
::v-deep .v-input__slot::after {
  display: none !important;
}

/* Кнопка Save */
.save-button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.save-button {
  min-width: 150px;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 6px;
  background-color: #007bff;
  color: #fff;
}

.offer-name {
  color: grey;
  font-weight: normal;
}
.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.geo-section {
  text-align: left;
}

.geo-label {
  font-weight: bold;
  font-size: 14px;
}

.geo-label.banned {
  color: red;
}

.geo-label.allowed {
  color: green;
}

.geo-content {
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.v-btn {
  text-transform: none !important;
}

.v-btn.warning {
  color: #ff6200 !important;
}
.geo-action-btn {
  letter-spacing: normal;
}
</style>


